const sortAltDown = ({ color, type }) => {
  const regular = (
    <svg
      width="14"
      height="9"
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.25295 8.159C6.34659 8.2647 6.4616 8.34932 6.59037 8.40727C6.71914 8.46522 6.85874 8.49519 6.99995 8.49519C7.14116 8.49519 7.28076 8.46522 7.40953 8.40727C7.5383 8.34932 7.65331 8.2647 7.74695 8.159L13.52 1.664C14.094 1.02 13.636 0 12.773 0H1.22695C0.36495 0 -0.0930506 1.02 0.479949 1.665L6.25295 8.159Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default sortAltDown;
